import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from 'src/config/api/models/User';

export interface AuthState {
  jwt?: string | null | undefined;
  user?: User;
  sessionId?: string;
  targetURI: string | null;
}

const initialState: AuthState = { targetURI: null };

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setJwt: (state, action: PayloadAction<string | null>) => {
      state.jwt = action.payload;
    },
    setUser: (state, action: PayloadAction<User | undefined>) => {
      state.user = action.payload;
    },
    setSessionId: (state, action: PayloadAction<string | undefined>) => {
      state.sessionId = action.payload;
    },
    setTargetURI: (state, action: PayloadAction<AuthState['targetURI']>) => {
      return { ...state, targetURI: action.payload };
    },
  },
  extraReducers: (_) => {},
});

export const { setJwt, setUser, setSessionId, setTargetURI } = authSlice.actions;
export const { reducer: authReducer } = authSlice;
